import React from "react";
import { OverlayBadge } from "./OverlayBadge";
import { useEditPanelState } from "../../graphql/hooks";

export const TemplatorConfigCheckOverlayBadge = () => {
    const { templatorConfigCheck } = useEditPanelState();

    if (!templatorConfigCheck) {
        return null;
    }

    return (
        <OverlayBadge
            badgeHeader="Invalid Templator Config!"
            badgeVariant="danger"
            overlayText="Missing or invalid templator config"
            className="mt-2 p-1 me-2"
        />
    );
};
